import { useState } from 'react';
import { getRole } from '../roles/role';
// const API_URL = process.env.REACT_APP_AXO_PEOPLE_API_URL; 
import { API_URL } from '../config';

export async function handleLogin({ email, password }) {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "X-Client-Platform": "WEB"
      },
      body: JSON.stringify({ email, password }),
    });

    let data;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      const text = await response.text();
      try {
        data = JSON.parse(text);
      } catch {
        data = { message: text };
      }
    }

    if (!response.ok) {
      const errorText = data?.message || data?.error || (typeof data === 'string' ? data : `Login failed (${response.status})`);
      console.error("Backend error:", errorText);
      throw new Error(errorText);
    }

    if (data.token) {
      localStorage.setItem("token", data.token);

      // setup auto logout after 24h (86400000 ms)
      setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("userRole");
        window.location.href = "/login"; // redirect user
      }, 24 * 60 * 60 * 1000);
    }

    if (data.role) {
      localStorage.setItem("userRole", data.role);
      console.log("Role set:", data.role);
    }

    // After login, fetch /me to detect Project Manager position
    if (data.token) {
      try {
        const meResponse = await fetch(`${API_URL}/me`, {
          headers: {
            Authorization: `Bearer ${data.token}`,
            'Content-Type': 'application/json',
            // 'X-Client-Platform': 'WEB',
          },
        });
        if (meResponse.ok) {
          const me = await meResponse.json();
          // Store employeeId for reuse
          if (me.employeeId || me.id) {
            localStorage.setItem('employeeId', me.employeeId || me.id);
          }
          // Detect Project Manager position
          const positions = me.positions || [];
          const isProjectManager = positions.some(
            (p) => p?.positionName?.toLowerCase() === 'project manager'
          );
          if (isProjectManager) {
            localStorage.setItem('userPosition', 'Project Manager');
            // Store projectName so we know which team they manage
            localStorage.setItem('userProjectName', me.projectName || '');
            // Store secondProjectName (additional projects separated by '-')
            localStorage.setItem('userSecondProjectName', me.secondProjectName || '');
          } else {
            localStorage.removeItem('userPosition');
            localStorage.removeItem('userProjectName');
            localStorage.removeItem('userSecondProjectName');
          }
        }
      } catch (meErr) {
        console.warn('Could not fetch /me after login:', meErr);
      }
    }

    return data;
  } catch (error) {
    console.error("Login failed:", error.message || error);
    throw error;
  }
}


//  export async function handleLogin ({ email, password})  {

//     try {
//       const response = await fetch(`${API_URL}/auth/login`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, password }),
//       });
//       const data = await response.json();
//       console.log(data.role);
//       if (data.token) {
//         localStorage.setItem('token', data.token);
//       }
//       if (data.role) {
//         localStorage.setItem('userRole', data.role);
//         console.log(localStorage.getItem('userRole'));
//       }
//       if (!response.ok) {       
//       const errorText = await response.text();       
//       console.error('Backend error:', errorText);       
//       throw new Error('Login failed: ' + errorText);     
//     } 

//     return data;   
//     } catch (error) {
//       console.error('Login failed:', error);
//       throw error;
//     }
//   };



export async function sendResetEmail(email) {
  const response = await fetch(`${API_URL}/auth/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Failed to send reset email');
  }
  return response.json();
}


export async function resetPassword(token, password) {
  const response = await fetch(`${API_URL}/auth/reset-password`, { // Updated endpoint
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, password }),
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Failed to reset password');
  }
  return response.json();
}
